import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../../lib/motion";
import { PRODUCT_CARDS } from "../../lib/product";
import { SectionIntro, STATUS_TONES } from "./shared";

const ConstructionIntelligenceCards = () => (
    <section
        id="suite"
        data-testid="construction-intelligence-cards-section"
        className="relative bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <SectionIntro
                testid="suite-intro"
                eyebrow="THE PRODUCT SUITE"
                title="Construction intelligence doesn't stop at the design."
                copy="Five connected instruments, one project. Each one carries the same verified foundation."
            />

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14 flex gap-6 overflow-x-auto pb-4 md:grid md:grid-cols-3 md:overflow-visible lg:grid-cols-5"
            >
                {PRODUCT_CARDS.map((card) => {
                    const tone = STATUS_TONES[card.tone];
                    return (
                        <motion.article
                            key={card.id}
                            variants={fadeUp}
                            data-testid={`product-card-${card.id}`}
                            className="group flex w-[280px] shrink-0 flex-col border border-white/12 bg-[#0C1428] transition-transform duration-500 hover:-translate-y-1 md:w-auto md:shrink"
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={card.image}
                                    alt={card.alt}
                                    loading="lazy"
                                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                                />
                                <span
                                    className={`absolute right-3 top-3 inline-flex items-center gap-1.5 border bg-[#0A0F1D]/75 px-2 py-1 font-mono text-[13px] tracking-[0.22em] backdrop-blur-sm ${tone.border} ${tone.text}`}
                                >
                                    <span
                                        className={`h-1 w-1 rounded-full ${tone.dot}`}
                                    />
                                    {card.status}
                                </span>
                            </div>
                            <div className="flex flex-1 flex-col px-5 py-5">
                                <h3 className="flex items-center gap-2 text-[16px] font-semibold text-white">
                                    <span className="h-1.5 w-1.5 bg-accent" />
                                    {card.title}
                                </h3>
                                <p className="mt-3 flex-1 text-[15px] leading-relaxed text-mist">
                                    {card.copy}
                                </p>
                                <Link
                                    to={card.href}
                                    data-testid={`product-card-link-${card.id}`}
                                    className="mt-5 inline-flex items-center gap-1.5 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                                >
                                    Learn more
                                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5" />
                                </Link>
                            </div>
                        </motion.article>
                    );
                })}
            </motion.div>
        </div>
    </section>
);

export default ConstructionIntelligenceCards;
